import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TeamsOverview from './components/TeamsOverview';
import TeamPage from './components/TeamPage';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Footer from './components/Footer';
import TeamDescription from './components/TeamDescription';
import RoleDetails from './components/RoleDetails';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        <header>
          <Navigation />
        </header>
        <main>
          <Routes>
            <Route path="" element={<Home />} />
            <Route path="teams" element={<TeamsOverview />} />
            <Route path="teams/:teamName" element={<TeamPage />} />
            <Route path="team-description" element={<TeamDescription />} />
            <Route path="role/:roleId" element={<RoleDetails />} />
          </Routes>
        </main>
        <footer>
          <Footer />
        </footer>
      </div>
      <ScrollToTop />
    </Router>
  );
}

export default App;
